import { render, staticRenderFns } from "./PackingLabel.vue?vue&type=template&id=39c92c7f&"
import script from "./PackingLabel.vue?vue&type=script&lang=js&"
export * from "./PackingLabel.vue?vue&type=script&lang=js&"
import style0 from "./PackingLabel.vue?vue&type=style&index=0&lang=scss&scopped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports